import React from 'react';
import { useTranslation } from 'react-i18next';
import filterTrayUrl from '../../../../../../assets/image/sidebarIcons/filter.png';
import { useDashboardPageOptionsContext } from '../dashboards/contexts';
import { SideBarListItem } from './SideBarListItem';
import { FilterState, IntercomArticleKeys } from './types';

interface FilterMenuItemProps {
  setDrawerState: (value: FilterState) => void;
}

export const FilterMenuItem = (props: FilterMenuItemProps) => {
  const { t } = useTranslation();
  const options = useDashboardPageOptionsContext();
  const showFilterTray = options.filterTray?.enabled ?? true;
  return (
    <SideBarListItem
      iconUrl={filterTrayUrl}
      text={t('common:dashboardSideBar.filter')}
      onClick={() => props.setDrawerState('main')}
      className="intercom_sidebar_filter"
      key="filter"
      disabled={!showFilterTray}
      data-cy="panalyt-dashboard-sidebar-filters"
      intercomArticleKey={IntercomArticleKeys.FILTER_TRAY}
    />
  );
};
